module.exports = __webpack_public_path__ + "img/img5.4c653e4c.jpg";